import React from 'react';
import Modal from '../../../../../Components/Modal/Modal';
import ElectronicExaminationCreateForm, {
	TYPE_STANDARD,
} from './ElectronicExaminationCreateForm';
import { NCZIEntry } from '../../../Interfaces/ncziTypes';

interface Props {
	opened: boolean;
	onClose: (needReload: boolean) => void;
	patientIdentifier: string;
	takeOverExamination?: NCZIEntry;
	type?: string;
}

const ElectronicExaminationCreateModal: React.FC<Props> = props => {
	const {
		opened,
		onClose,
		patientIdentifier,
		takeOverExamination,
		type = TYPE_STANDARD,
	} = props;

	return (
		<Modal opened={opened} onClose={() => onClose(false)} fullScreen={false}>
			<Modal.Header
				title={
					type === TYPE_STANDARD
						? 'nczi.examination.create.titleZoOV'
						: 'nczi.examination.create.titleZZS'
				}
				firstUpper
			/>
			<Modal.Content>
				<ElectronicExaminationCreateForm
					onClose={onClose}
					patientIdentifier={patientIdentifier}
					takeOverExamination={takeOverExamination}
					type={type}
				/>
			</Modal.Content>
		</Modal>
	);
};

export default ElectronicExaminationCreateModal;
